import { SimpleList, SimpleListItem, Stack } from '@optimus-web/core';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { LocalizedParagraph } from '@mews-commander/ui';
import { FAQAccordion } from './FAQAccordion';

const WhoIsYoulend = () => (
    <FAQAccordion
        data-test-id={DataTestId.CapitalFAQWhoIsYoulend}
        primaryTextKey={TextKey.FinancialServicesCapitalWhoIsYoulend}
        body={
            <Stack vertical>
                <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalYoulandIsFinancingProvider} />
                <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalYoulandTrustpilotRaiting} />
                <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalYoulandTrustpilotRaitingMayChange} />
            </Stack>
        }
    />
);

const WhatInfoDoINeed = () => {
    const requirementsList = [
        { id: 'companyDetails', value: TextKey.FinancialServicesCapitalCompanyDetailsText },
        { id: 'personalDetails', value: TextKey.FinancialServicesCapitalInfoToApplyPersonalDetails },
        { id: 'financialInformation', value: TextKey.FinancialServicesCapitalInfoToApplyFinancialInfo },
    ];

    return (
        <FAQAccordion
            data-test-id={DataTestId.CapitalFAQWhatInfoDoINeed}
            primaryTextKey={TextKey.FinancialServicesCapitalWhatInfoDoINeedToApply}
            body={
                <Stack vertical>
                    <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalYouWillNeedTheFollowing} />
                    <SimpleList ordered>
                        {requirementsList.map(({ id, value }) => (
                            <SimpleListItem key={id}>
                                <LocalizedParagraph textKey={value} />
                            </SimpleListItem>
                        ))}
                    </SimpleList>
                </Stack>
            }
        />
    );
};

const WhenWillTheFundsBeReceived = () => (
    <FAQAccordion
        data-test-id={DataTestId.CapitalFAQWhenWillTheFundsBeReceived}
        primaryTextKey={TextKey.FinancialServicesCapitalWhenWillTheFundsBeReceived}
        body={<LocalizedParagraph textKey={TextKey.FinancialServicesCapitalYouWillBePresentedWithOffers} />}
    />
);

const HowIsYouLendDifferent = () => (
    <FAQAccordion
        data-test-id={DataTestId.CapitalFAQHowIsYouLendDifferent}
        primaryTextKey={TextKey.FinancialServicesCapitalHowIsFundingDifferent}
        body={<LocalizedParagraph textKey={TextKey.FinancialServicesCapitalTheFundingIsBasedOnRelationship} />}
    />
);

export const QuestionsList = () => (
    <Stack vertical spacing="300">
        <WhoIsYoulend />
        <WhatInfoDoINeed />
        <WhenWillTheFundsBeReceived />
        <HowIsYouLendDifferent />
    </Stack>
);
